import React, { useEffect, useState, useContext } from 'react';
import styles from './style.module.scss';
import { useHistory, useLocation } from 'react-router-dom';
import HamburgerCustom from './HamburgerCustom';
import style from '../../pages/Account/style.module.scss';
import RenderSvgIcon from '../RenderSvgIcon';
import { AppContext } from '../../context/AppContext';



const wrapStyleArrow = {
  paddingRight: 3,
  width: 24,
  height: 24,
  color: 'var(--text-secondary)',
  fill: 'currentColor',
  cursor: 'pointer',
};

function TopNavCustom(props) {
  const appContext = useContext(AppContext);
  const history = useHistory();
  const location = useLocation();

  const listEnvInfo = appContext.listEnvInfo;

  const backToSetting = () => {
    if (props?.dir) {
      history.push(props.dir);
      return;
    }

    history.goBack();
  };

  const [mainColor, setMainColor] = useState('#8f8f8f');

  useEffect(() => {
    if (listEnvInfo) {
      const color = (listEnvInfo ?? []).find((data) => data.code === '--text1');
      if (color?.content) {
        setMainColor(color.content);
      }
    }
  }, [listEnvInfo]);

  const clickLogo = () => {
    if (props?.preventLogoClick) {
      return;
    }
    history.push(`${process.env.RAZZLE_PUBLIC_URL}/home`);
  };

  const topNavibarLogo = listEnvInfo?.find((item) => item.code === 'top_navibar_logo');

  return (
    <div
      style={{ paddingRight: '0px !important', position:"fixed" }}
      className={`${styles.top__nav} height-top-navi`}
    >
      <div style={{ position: 'relative' }}>
        {props?.hasLogo && topNavibarLogo && (
          <div className={`${styles.web__logo} d-box-logo`} onClick={clickLogo}>
            <img src={topNavibarLogo?.content} className={style.icon} alt="Contact" />
          </div>
        )}
        <h6 variant="h6" className="font-1" style={{ lineHeight: 2.4, textAlign: 'center' }}>
          {props?.name}
        </h6>
        {props.hasBackIcon && (
          <span className={`${styles.backIcon} iframe-pre-hidden-btn`} onClick={backToSetting}>
            <RenderSvgIcon name="SVG_forward_left_icon" style={wrapStyleArrow} className={'d-svg'} />
          </span>
        )}

        {props?.hasHamburgerCustom && <HamburgerCustom dataHumburgerCustom={props.dataHumburgerCustom} />}
      </div>
    </div>
  );
}

export default TopNavCustom;
